<template>
  <v-container fluid fill-height class="loginOverlay">
    <v-layout flex align-center justify-center>
      <v-flex xs12 md6 lg4 elevation-6>
        <v-toolbar class="pa-4 tool-bar-app darken-1" style="height: 100%;">
          <v-layout justify-center align-center style="height: 100%;">
            <img class="login--logo" src="@/assets/imagens/logo_mono_cp.png" alt="Logo siged">
          </v-layout>
        </v-toolbar>
        <v-card>
          <v-card-text class="pt-4">
            <div>
              <v-form @submit.prevent="submit" ref="form">
                <Validator style="width: 100%;" :v="$v.cpf">
                  <v-text-field label="CPF*" :mask="'###.###.###-##'" v-model="cpf" />
                </Validator>
                <Validator style="width: 100%;" :v="$v.email">
                  <v-text-field label="E-mail*" v-model="email" @input="email = email.toLowerCase()" />
                </Validator>
                <Validator style="width: 100%;" :v="$v.senha">
                  <v-text-field type="password" label="Senha*" v-model="senha" />
                </Validator>
                <Validator style="width: 100%;" :v="$v.confirmarSenha">
                  <v-text-field type="password" label="Confirmar Senha*" v-model="confirmarSenha" />
                </Validator>
                <v-alert
                  :value="message"
                  :type="messageType"
                  transition="scale-transition"
                >
                  {{message}}
                </v-alert>
                <v-btn :loading="sending" class="accent white--text rounded-sm font-weight-regular" type="submit">
                  Cadastrar
                </v-btn>
                <v-btn to="/login" class="accent white--text rounded-sm font-weight-regular" style="margin-left: 15px;">Voltar</v-btn>
              </v-form>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  email,
  sameAs,
} from 'vuelidate/lib/validators';
import authRepository from '@/repositories/authRepository.js';
import {validaCpf} from '@/utils/validaCpf';

export default {
  data(){
    return {
      email: '',
      senha: '',
      confirmarSenha: '',
      cpf: '',
      sending: false,
      message: null,
      messageType: null
    };
  },
  validations(){
    return {
      email: { required, email },
      cpf: { required, maxLength: maxLength(11), minLength: minLength(11), validaCpf },
      senha: { required, minLength: minLength(8) },
      confirmarSenha: { sameAs: sameAs('senha'), minLength: minLength(8) },
    };
  },
  methods: {
    async submit(){
      this.$v.$touch();
      if (this.$v.$invalid){return;}

      this.sending = true;
      try {
        const response = await authRepository.cadastrar({
          email: this.email,
          cpf: this.cpf,
          senha: this.senha
        });

        this.message = response.data.message;
        this.messageType = 'success';
        setTimeout(() => this.$router.push('/login'), 3000);
      } catch (error) {
        this.message = error.response.data.errorMessage;
        this.messageType = 'error';
      }
      finally{
        this.sending = false;
        return;
      }
    },
  },
  watch: {
    message(){
      if (this.message)
        setTimeout(() => this.message = null, 8000);
    }
  }
};
</script>

<style lang="scss" scoped>
.loginOverlay {
  background-image: url("~@/assets/login-bg.png");
  background-repeat: repeat;
}

.login--logo {
  height: 100%;
}
</style>
